/**
 * WbToggleGroup — exclusieve keuze uit 2 tot 4 opties (radiogroup).
 *
 * Vervangt het segment en de <select> voor vorm en soort-snelkeuze.
 * Tegels 54 px hoog, naast elkaar.
 */

import clsx from 'clsx';

export interface WbToggleOption<T extends string> {
  value: T;
  label: string;
  icon?: React.ReactNode;
}

export interface WbToggleGroupProps<T extends string> {
  options: WbToggleOption<T>[];
  value: T | null | undefined;
  onChange: (value: T) => void;
  label?: string;
  className?: string;
}

export function WbToggleGroup<T extends string>({ options, value, onChange, label, className }: WbToggleGroupProps<T>) {
  return (
    <div
      role="radiogroup"
      aria-label={label}
      className={clsx('grid gap-2', className)}
      style={{ gridTemplateColumns: `repeat(${Math.min(options.length, 4)}, minmax(0, 1fr))` }}
    >
      {options.map((opt) => {
        const actief = opt.value === value;
        return (
          <button
            key={opt.value}
            type="button"
            role="radio"
            aria-checked={actief}
            onClick={() => onChange(opt.value)}
            className={clsx(
              'wb-focus min-h-[54px] flex items-center justify-center gap-2 px-2 rounded-wb border-wb font-wb-heading font-bold text-base select-none',
              actief
                ? 'bg-wb-inkt border-wb-inkt text-white'
                : 'bg-wb-vlak border-wb-rand text-wb-inkt active:bg-wb-gedempt'
            )}
          >
            {opt.icon}
            <span>{opt.label}</span>
          </button>
        );
      })}
    </div>
  );
}
